<template>
  <div class="card card-alert" v-bind:class="[ readonly === true ? 'readOnly' : 'normalMode' ]">
    <div class="card-inner">
      <div class="card-row" v-if="sounds && sounds.volume && sounds.authorization">
        <div class="title-container">
          <span class="title">
            {{ $t('profile.sound_effect.prealert.title') }}
          </span>
          <span class="icon">
            <i class="fa fa-volume-up" aria-hidden="true"></i>
          </span>
        </div>
        <div class="content-container">
          <div>
            {{ $t('profile.sound_effect.prealert.volume') }}: {{ sounds.volume.value }}%
          </div>
          <div class="range-input">
            <input
                type="range"
                class="form-input"
                :disabled="readonly"
                :class="{'over-threshold': sounds.volume.value < 60 }"
                @change="modification('config')"
                v-model="sounds.volume.value"
                :min="sounds.volume.values.min"
                :max="sounds.volume.values.max"
                :step="sounds.volume.values.step"
            />
          </div>
          <div class="volume-warning" v-show="sounds.volume.value < 60">
            {{ $t('profile.sound_effect.prealert.volume_warning') }}
          </div>
          <div class="switch-input">
            <b-form-checkbox class="switcher"
                             :disabled="readonly"
                             v-model="sounds.authorization.value"
                             @change="modification('config')"
                             value="1"
                             unchecked-value="0"
                             switch>
              <span>{{ $t('profile.sound_effect.prealert.volume_adjustable') }}</span>
            </b-form-checkbox>
            <div class="switch-input__warning" v-if="sounds.authorization.value == 1">
              {{ $t('profile.sound_effect.prealert.volume_adjustable_warning') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BFormCheckbox} from "bootstrap-vue";

export default {
  name: 'CardAlertSoundEffect',
  components: {
    BFormCheckbox,
  },
  props: {
    sounds: {
      type: [Object, null],
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    modification() {
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-alert {
  padding-right: 5px;
  padding-left: 5px;
}

.title {
  margin-left: 0px !important;
  margin-top: 8px !important;
}

.icon {
  font-size: 25px !important;
}

.card, .card-inner {
  border: none !important;
  padding-bottom: 18px !important;
}

.title-container {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.content-container, .title-container {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

input[type=range] {
  width: 100% !important;
  margin-right: 20px;
  height: 10px;
}

.range-input {
  &__warning {
    color: #e74c3c;
    font-weight: 600;
    padding: 5px;
  }
}

.switch-input {
  &__warning {
    color: #e74c3c;
    font-weight: 600;
    padding: 10px 5px 5px 5px;
    font-size: 0.8rem;
  }
}

.volume-warning {
  color: #e74c3c;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0 5px 5px 5px;
  margin-bottom: 10px;
}
</style>
